/*
 |--------------------------------------------------------------------------
 | Questions / mutation_types.js
 |--------------------------------------------------------------------------
 */

export const SET_BOAT_TYPE = 'SET_BOAT_TYPE'
export const SET_BOAT_MATERIAL = 'SET_BOAT_MATERIAL'
export const SET_SAIL_FREQUENCY = 'SET_BOAT_FREQUENCY'
export const SET_COUNTRY = 'SET_COUNTRY'
export const LOCAL_PRODUCTS = 'LOCAL_PRODUCTS'
